import createVueComponent from '../createVueComponent';

const SidebarClose = createVueComponent('SidebarCloseIcon', [
  ['rect', { x: '3', y: '3', width: '18', height: '18', rx: '2', ry: '2' }],
  ['line', { x1: '9', y1: '3', x2: '9', y2: '21' }],
  ['path', { d: 'M17 16l-4-4 4-4' }],
]);

export default SidebarClose;
